<template>
  <div>
    <loading-overlay
      v-if="updatingClients || updatingUnapprovedEvents"
      :text="''"
    />
    <v-container fluid class="px-6 py-6">
      <!-- Unapproved Events Alert - For all users -->
      <v-alert
        v-if="unapprovedEventsCount > 0"
        type="error"
        prominent
        border="left"
        class="mb-6"
      >
        <v-row align="center">
          <v-col class="grow">
            <div class="text-h6 font-weight-bold">
              <template v-if="isSuperAdmin">
                {{ unapprovedEventsCount }} {{ unapprovedEventsCount === 1 ? 'Event wartet' : 'Events warten' }} auf Freigabe
              </template>
              <template v-else>
                Ihre Events warten auf Genehmigung
              </template>
            </div>
            <div v-if="isSuperAdmin" class="text-body-2">
              Bitte prüfe die Events und gebe sie frei oder lehne sie ab.
            </div>
          </v-col>
          <v-col class="shrink">
            <v-btn
              color="white"
              outlined
              @click="scrollToUnapprovedEvents"
            >
              <i class="material-icons-round me-2">visibility</i>
              Anzeigen
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>

      <v-row>
        <v-col cols="12">
          <v-row class="mt-0 ml-1" justify="space-between">
            <!-- <v-btn
              elevation="0"
              height="43"
              class="font-weight-bold text-uppercase btn-default bg-gradient-primary py-2 px-6 me-2 mb-sm-0 mb-2"
              color="#5e72e4"
              small
              @click="$router.push('/admin/events/new').catch(() => {})"
              >Neuen Kunden anlegen</v-btn
            > -->
            <div class="mr-2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="$store.dispatch('getClients')"
                    v-bind="attrs"
                    v-on="on"
                    class="material-icons-round text-primary ms-auto"
                    size="30"
                  >
                    refresh
                  </v-icon>
                </template>
                <span>Aktualisieren</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row class="mb-6 mt-3">
            <v-col
              v-for="client in clients"
              :key="client.Id"
              cols="12"
              md="6"
              lg="4"
              class="pt-0 mb-10"
            >
              <ClientCard :client="client" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="unapprovedEventsCount > 0" data-unapproved-events>
        <v-col cols="12">
          <datatable-not-approved></datatable-not-approved> </v-col
      ></v-row>
    </v-container>
  </div>
</template>
<script>
// import CalendarWidget from "./Widgets/CalendarWidget.vue";
import ClientCard from "./Widgets/ClientCard.vue";
import administrationData from "@/mixins/administrationMixin";
import permissionMixin from "@/mixins/permissionMixin";
import PermissionDenied from "@/components/PermissionDenied.vue";
import DatatableNotApproved from "./Widgets/DatatableNotApproved.vue";
export default {
  name: "AdministrationOverview",
  mixins: [administrationData, permissionMixin],
  components: {
    ClientCard,
    DatatableNotApproved,
    PermissionDenied,
  },
  data: function () {
    return {};
  },
  mounted() {
    this.$store.dispatch("getClients");
    if (!this.selectedYear) {
      this.$store.commit("selectedYear", this.currentYear);
    }
    // Load events to get unapproved count - use current year
    const yearToUse = this.$store.getters.selectedYear || this.currentYear;
    console.log('📅 [ADMIN OVERVIEW] Loading events with year:', yearToUse);
    this.$store.dispatch("getEventsAdmin", { 
      includeArchived: false,
      year: yearToUse 
    });
  },
  computed: {
    events() {
      return this.$store.getters.events || [];
    },
    isSuperAdmin() {
      // Only user with ID 60b89cf155a3dc11c0e06393 is superadmin
      return this.userInformations && this.userInformations._id === '60b89cf155a3dc11c0e06393';
    },
    unapprovedEventsCount() {
      // Count unapproved events from all events (backend returns all events)
      return this.events.filter(event => !event.approved).length;
    },
  },
  methods: {
    scrollToUnapprovedEvents() {
      // Scroll to the datatable section
      const element = document.querySelector('[data-unapproved-events]');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  },
};
</script>
